export default "__VITE_ASSET__BEye73nK__"